<template>
    <div class="loading" v-show="show">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            show: false
        }
    },
    mounted() {
        this.$bus.on('showLoad', () => {
            this.show = true;
        })
        this.$bus.on('hideLoad', () => {
            this.show = false;
        })
    }
}
</script>
<style>
    .loading {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2000;
        text-align: center;
        background: rgba(0, 0, 0, .7);
        z-index: 2500;
    }

    .loading > div {
        position: relative;
        display: inline-block;
        width: 20px;
        height: 20px;
        top: 50%;
        margin-top: -10px;
        background-color: white;
        border-radius: 100%;
        -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
        animation: bouncedelay 1.4s infinite ease-in-out;
        /* Prevent first frame from flickering when animation starts */
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }

    .loading .bounce1 {
        animation-delay: -0.32s;
    }

    .loading .bounce2 {
        animation-delay: -0.16s;
    }

    @keyframes bouncedelay {
        0%,
        80%,
        100% {
            transform: scale(0);
        }
        40% {
            transform: scale(1);
        }
    }
</style>